import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';

import { RepositoryComponent } from './repository.component';
import { SitesPageComponent } from './sites-page/sites-page.component';
import { SitesComponent } from './sites/sites.component';
import { SiteEditComponent } from './sites/site-edit/site-edit.component';
import { AddressesPageComponent } from './addresses-page/addresses-page.component';
import { SiteGroupsComponent } from './site-groups/site-groups.component';
import { SiteGroupEditComponent } from './site-groups/site-group-edit/site-group-edit.component';
import { AddressesComponent } from './addresses/addresses.component';
import { AddressGroupsComponent } from './address-groups/address-groups.component';
import { AddressGroupEditComponent } from './address-groups/address-group-edit/address-group-edit.component';
import { AddressEditComponent } from './addresses/address-edit/address-edit.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientEditComponent } from './clients/client-edit/client-edit.component';
import { TransportTypesComponent } from './transport-types/transport-types.component';
import { TransportTypeEditComponent } from './transport-types/transport-type-edit/transport-type-edit.component';
import { ProductTypesComponent } from './product-types/product-types.component';
import { ProductTypeEditComponent } from './product-types/product-type-edit/product-type-edit.component';
import { ContainersComponent } from './containers/containers.component';
import { ContainerEditComponent } from './containers/container-edit/container-edit.component';

@NgModule({
  declarations: [
    RepositoryComponent,
    SitesPageComponent,
    SitesComponent,
    SiteEditComponent,
    AddressesPageComponent,
    SiteGroupsComponent,
    SiteGroupEditComponent,
    AddressesComponent,
    AddressGroupsComponent,
    AddressGroupEditComponent,
    AddressEditComponent,
    ClientsComponent,
    ClientEditComponent,
    TransportTypesComponent,
    TransportTypeEditComponent,
    ProductTypesComponent,
    ProductTypeEditComponent,
    ContainersComponent,
    ContainerEditComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class RepositoryModule { }
